import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter } from 'rxjs';

@Component({
    selector: 'app-breadcrumbs',
    template: `<p-breadcrumb
        [home]="home"
        [model]="menuItems"
        [class.empty]="menuItems.length === 0"
        [homeAriaLabel]="'Home'"></p-breadcrumb>`,
    standalone: true,
    imports: [BreadcrumbModule],
})
export class BreadcrumbsComponent implements OnInit {
    static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    home = {
        icon: 'fa-regular fa-home',
        url: AppRoutes.routes().DASHBOARD,
        label: '',
        routerLink: [AppRoutes.routes().DASHBOARD],
    };
    menuItems: MenuItem[] = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationSkipped))
            .subscribe(() => (this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)));
    }

    // We do this in case the group id gets updated
    private calculateHomeLink() {
        this.home.url = AppRoutes.routes().DASHBOARD;
        this.home.routerLink = [AppRoutes.routes().DASHBOARD];
    }

    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
        this.calculateHomeLink();
        const children: ActivatedRoute[] = route.children;

        children.forEach(child => {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const label = child.snapshot.data[BreadcrumbsComponent.ROUTE_DATA_BREADCRUMB];

            if (label !== null && label !== undefined) {
                breadcrumbs.push({ label: this.translate.instant(label), url, target: '_self', routerLink: [url] });
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        });

        return breadcrumbs;
    }
}
